export default __webpack_public_path__ + "static/media/pin-icon.b908376b.svg";